import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CardsSection = ({ cardData }) => {
  if (!cardData || cardData.length === 0) return null;

  // Dynamically set card width based on number of cards
  const cardWidth =
    cardData.length === 2
      ? { xs: '400px', lg: '520px' }
      : { xs: '260px', lg: '332px' };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: { xs: '32px', lg: '48px' },
        mt: '40px',
        mb: '40px',
        flexWrap: 'wrap',
      }}
    >
      {cardData.map((card, index) => (
        <Card
          key={index}
          sx={{
            width: cardWidth,
            backgroundColor: card.color,
            color: '#ffffff',
            borderRadius: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '260px',
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: '28px',
                fontWeight: 400,
                mb: '12px',
              }}
            >
              {card.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'PT Sans, sans-serif',
                fontSize: '16px',
                lineHeight: 1.4,
              }}
            >
              {card.description}
            </Typography>
          </CardContent>

          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Button
              component={RouterLink}
              to={card.link}
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: '18px',
                fontWeight: 600,
                color: card.color,
                backgroundColor: '#ffffff',
                textTransform: 'none',
                borderRadius: '8px',
                px: 3,
                py: 1,
                '&:hover': {
                  backgroundColor: '#f0f0f0',
                },
              }}
            >
              {card.buttonText}
            </Button>
          </Box>
        </Card>
      ))}
    </Box>
  );
};

export default CardsSection;
